import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

export default function Feature3Item({ data, slice }) {
  return (
    <div className={`w-full`}>
      <div className="w-full max-w-[335px] md:max-w-[374px] lg:max-w-[342px] mx-auto flex flex-nowrap gap-[20px] items-start">
        {data.icon?.url && (
          <PrismicNextImage
            className="w-[50px] h-[50px]"
            field={data.icon}
            fallbackAlt=""
          />
        )}
        <div>
          <div className="title-medium title-font mb-[6px] md:mb-[12px] text-[#1F2223]">
            <PrismicRichText field={data?.title} />
          </div>
          <div className="text-base text-[#1F2223]">
            <PrismicRichText field={data?.text} />
          </div>
        </div>
      </div>
    </div>
  );
}
